import React from 'react';
import FooterComp from '../components/Footer/Footer';
import HeaderComp from '../components/Header/Header';
import TrainingVideo from '../components/TrainingVideo/TrainingVideo';
import TrainingVideoHeader from '../components/TrainingVideo/TrainingVideoHeader';
import config from '../config/config';
import seo from '../config/seo';
import SetHeaders from '../config/SetHeaders';
import Head from 'next/head';
import axios from 'axios';

const TrainginVideoContainer = ({ Header, Body, Footer, response }: any) => {

  const components = (typeName: any, compData: any, key: any) => {
    switch (typeName) {
      case 'connect.page-heading-widget':
        return <TrainingVideoHeader key={key} data={compData} />;
      case 'page.video-player-card-group':
        return <TrainingVideo key={key} data={compData} />;

      default:
        return null;
    }
  };

  return (
    <React.Fragment>
      {response && !response.Seo && (
        <Head>
          <title>{seo.training}</title>
        </Head>
      )}
      {response && <SetHeaders HEADERS={response} />}
      {Header && <HeaderComp HeaderValue={Header} />}
      <div className="app-body">
        {Body &&
          Body.map((data: any, i: number) => {
            return components(data.__component, data, i);
          })}
      </div>
      {Footer && <FooterComp data={Footer} />}
    </React.Fragment>
  );
};

export async function getStaticProps() {
  const { data } = await axios.get(config.endpoints.trainingVideo)
  return {
    props: {
      Header: data.Header,
      Body: data.Body,
      Footer: data.Footer.Footer,
      response: data
    },
    revalidate: 3600
  }
}

export default TrainginVideoContainer